import { usePOS } from '../context/POSContext.js';
import React from 'react';

function CategorySidebar() {
  const { categories, activeCategory, setActiveCategory } = usePOS();

  // Icône générique pour toutes les catégories
  const genericIcon = React.createElement('svg', {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-8 w-8",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  },
    React.createElement('path', {
      fillRule: "evenodd",
      d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
      clipRule: "evenodd"
    })
  );

  return React.createElement('div', { className: "flex flex-col h-full w-full pt-4 overflow-y-auto scrollbar-thin scrollbar-thumb-amber-400 scrollbar-track-amber-100" },
    categories.map((category) =>
      React.createElement('button', {
        key: category,
        className: `flex flex-col items-center justify-center py-4 w-full transition-colors ${
          activeCategory === category
            ? 'text-black' 
            : 'text-amber-200'
        }`,
        style: activeCategory === category ? { backgroundColor: '#fdf54d' } : {},
        onClick: () => setActiveCategory(category)
      },
        React.createElement('div', { className: "mb-1" }, genericIcon),
        React.createElement('span', { className: "text-xs capitalize" }, category)
      )
    )
  );
}

export default CategorySidebar;
